<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <t-form-item label="宽度">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="currentCpt.cptWidth"
        :decimal-places="0"
        disabled="true"
      />
    </t-form-item>
    <t-form-item label="高度">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.height"
        :decimal-places="0"
      />
    </t-form-item>
    <e-collapse title="滚动条配置" :expand="false">
      <t-form-item label="开启滚动条">
        <t-switch
          v-model="attribute.isScroll"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <t-form-item label="横向滚动条" >
        <t-switch
          v-model="attribute.xScroll"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      <t-form-item label="纵向滚动条" >
        <t-switch
          v-model="attribute.yScroll"
          size="small"
          :label="['开', '关']"
        />
      </t-form-item>
      
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
export default {
  name: "cpt-richtxt-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptData },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>